function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import useList from "../../../../utils/hooks/useList";
import { Divider, List } from 'antd';
import cls from 'classnames';
import { useCallback, useEffect, useState } from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import { useCssInJs } from "../../../../hooks";
import { useTaskList } from "../../TaskListStore";
import { ALL_START_TIME, CLASSIFY_CODE_ALL, LIST_API_MAP } from "../../constants";
import { KEY_FILTER1, KEY_FILTER2 } from "../../types/filter";
import ListItem from "./ListItem";
import { getLeftTaskListStyle } from "./styles";
import { jsx as _jsx } from "react/jsx-runtime";
export default function LeftTaskList() {
  var prefix = 'tasklist-left-task-list';
  var _useCssInJs = useCssInJs({
      prefix: prefix,
      styleFun: getLeftTaskListStyle
    }),
    wrapSSR = _useCssInJs.wrapSSR,
    hashId = _useCssInJs.hashId;
  var _useTaskList = useTaskList(),
    _useTaskList2 = _slicedToArray(_useTaskList, 2),
    snap = _useTaskList2[0],
    state = _useTaskList2[1];
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    selectedItem = _useState2[0],
    setSelectedItem = _useState2[1];
  var _useState3 = useState(LIST_API_MAP['default']),
    _useState4 = _slicedToArray(_useState3, 2),
    listApi = _useState4[0],
    setListApi = _useState4[1];
  var listData = useList({
    method: 'get',
    url: listApi,
    initialPage: {
      size: 20
    },
    initialQuery: _defineProperty(_defineProperty({}, KEY_FILTER1, '1'), KEY_FILTER2, '0')
  });
  var loading = listData.loading,
    data = listData.data,
    complete = listData.complete,
    error = listData.error,
    isEmpty = listData.isEmpty;
  var scrollProps = listData.scrollProps,
    query = listData.query,
    handleQuery = listData.handleQuery;
  var handleQueryChange = useCallback(function (query) {
    if (query) {
      // if (query.todoType === FILTER_MAP.已发起.value) {
      //   setListApi(LIST_API_MAP['已发起'])
      // } else {
      setListApi(LIST_API_MAP['default']);
      // }
      handleQuery(query);
    }
  }, [handleQuery]);
  useEffect(function () {
    // 设置默认值
    // 从data中取出第一个值
    if (data.length > 0) {
      state.flowParams = {
        taskOrderId: data[0].taskOrderId ? data[0].taskOrderId.toString() : undefined,
        flowOrderId: data[0].flowOrderId,
        detailLink: data[0].detailLink
      };
    } else {
      state.flowParams = {
        taskOrderId: undefined,
        flowOrderId: undefined,
        detailLink: undefined
      };
    }
  }, [data]);
  useEffect(function () {
    var _state$todoType, _state$todoTimeType;
    var params = {
      todoType: (_state$todoType = state.todoType) === null || _state$todoType === void 0 ? void 0 : _state$todoType.toString(),
      todoTimeType: (_state$todoTimeType = state.todoTimeType) === null || _state$todoTimeType === void 0 ? void 0 : _state$todoTimeType.toString()
    };
    if (state.startTime && state.endTime) {
      if (state.startTime === ALL_START_TIME) {
        delete state.startTime;
        delete state.endTime;
      } else {
        params.startTime = state.startTime;
        params.endTime = state.endTime;
      }
    }

    // console.log('state.classifyCode', state.classifyCode)
    if (state.classifyCode) {
      if (state.classifyCode === CLASSIFY_CODE_ALL) {
        delete state.classifyCode;
      } else {
        params.classifyCode = state.classifyCode;
      }
    }

    // console.log('query', query)
    // console.log('params', params)

    if (params.todoType) {
      handleQueryChange(_objectSpread({}, params));
    }

    // 选项变化的时候，选中第一个
    setSelectedItem(0);
  }, [state.todoType, state.todoTimeType, state.startTime, state.endTime, state.classifyCode]);
  return wrapSSR( /*#__PURE__*/_jsx("div", {
    id: "taskListScrollableDiv",
    className: cls(prefix, hashId, data.length ? '' : 'empty-list'),
    children: /*#__PURE__*/_jsx(InfiniteScroll, _objectSpread(_objectSpread({
      dataLength: data.length
    }, scrollProps), {}, {
      loader: null,
      endMessage: data.length > 0 ? /*#__PURE__*/_jsx(Divider, {
        className: "empty-text",
        children: "\u6CA1\u6709\u66F4\u591A\u6570\u636E"
      }) : null,
      scrollableTarget: "taskListScrollableDiv",
      children: /*#__PURE__*/_jsx(List, {
        className: "scrollable-list",
        itemLayout: "horizontal",
        dataSource: data,
        renderItem: function renderItem(item, index) {
          return /*#__PURE__*/_jsx(ListItem, {
            data: item,
            index: index,
            selectedItem: selectedItem,
            setSelectedItem: setSelectedItem
          });
        }
      })
    }))
  }));
}